export const CAREER_KEYS_ORDER = ["Position", "Company", "Employment period"];

// Stored CVs sometimes carry German keys because the LLM translation step
// renames keys despite instructions; accept both spellings so those entries
// still render.
const CAREER_KEY_ALIASES: { [key: string]: string[] } = {
  "Position": ["Position"],
  "Company": ["Company", "Unternehmen"],
  "Employment period": ["Employment period", "Beschäftigungszeitraum", "Zeitraum"],
};

export function getCareerValue(
  career: { [key: string]: string } | null | undefined,
  key: string
): string | undefined {
  const aliases = CAREER_KEY_ALIASES[key] || [key];
  return aliases.map((alias) => (career || {})[alias]).find((value) => value);
}
